module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0047.jpg?v=37a90f26";